let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("hD56l"), load("b1vDf")]).then(() => parcelRequire('6JR3B'));